import stacktrace from 'stacktrace-js';

var errback = function (err) { console.log(err.message); };

addEventListener("error", (event) => { })

window.addEventListener('error', e => {

    // Get the error properties from the error event object
    const { message, filename, lineno, colno, error } = e;

    var callback = function (stackframes) {
        console.log("fancy stack trace:", message);
        var stringifiedStack = stackframes.map(function (sf) {
            return sf.toString();
        }).join('\n');

        console.log(stringifiedStack);

        fetch('/api/error-reporter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ message, stringifiedStack, pageload: window.traceCode, url: window.location.href })
        }).catch(errback);
    };

    stacktrace.fromError(error).then(callback).catch(errback);

});